import axios from "../../axios";

const getAllDeposits = async function (accessToken, params = {}) {
    try {
        // Convert queryParams string to object if it exists

        const response = await axios.post(`admin/deposit/getAllDeposits`, params, {
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status,
            message: e.response.data.message
        }
    }
}

export default getAllDeposits; 
